/**
 * Informace o uživateli
 * @includeToDoc
 */
export interface IUser {
    /** Unikátní identifikátor (na úrovni datového modelu) */
    readonly id: number;
    /** Unikátní identifikátor (globální) */
    readonly guid: string;
    /** Uživatelské jméno (strojové) */
    readonly userName: string;
    /** Jméno, příjmení a tituly osoby */
    readonly fullName: string | null;
    /** Email uživatele */
    readonly email: string | null;
}
